module.exports = __webpack_public_path__ + "static/media/video.b39a4eb5.mp4";